import { render, staticRenderFns } from "./assetsImg2.vue?vue&type=template&id=1cfcd24c&scoped=true&"
import script from "./assetsImg2.vue?vue&type=script&lang=js&"
export * from "./assetsImg2.vue?vue&type=script&lang=js&"
import style0 from "./assetsImg2.vue?vue&type=style&index=0&id=1cfcd24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfcd24c",
  null
  
)

export default component.exports